/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Description_AdministrationInputs */

const en_settings_description_administration = /** @type {(inputs: Settings_Description_AdministrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Control tenant-level backstage behavior.`)
};

const de_settings_description_administration = /** @type {(inputs: Settings_Description_AdministrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Steuern Sie das mandantenweite Backstage-Verhalten.`)
};

/**
* | output |
* | --- |
* | "Control tenant-level backstage behavior." |
*
* @param {Settings_Description_AdministrationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const settings_description_administration = /** @type {((inputs?: Settings_Description_AdministrationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Description_AdministrationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_description_administration(inputs)
	return de_settings_description_administration(inputs)
});